import classNames from 'classnames';
import * as React from 'react';
import { Modal } from '../Modal';
import { Button } from '~/Partials/Button/Button';
import { ButtonType } from '~/Partials/Button/ButtonType.csharp';
import { SvgIcon } from '~/Partials/SvgIcon/SvgIcon';
import styles from './PopupDialog.module.css';

export interface PopupDialogTranslations {
    closeModal: string;
}

export interface PopupDialogProps {
    isOpen: boolean;
    onClose: () => void;
    translations: PopupDialogTranslations;
    title?: string;
    className?: string;
    variant?: 'default' | 'modern';
}

export const PopupDialog: React.FC<React.PropsWithChildren<PopupDialogProps>> = props => {
    const { isOpen, onClose, title, translations, children, className, variant = 'default' } = props;

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            withWrapper
            variant="centered"
            className={classNames(className, variant !== 'default' && styles[`Variant--${variant}`])}
            contentClassName={styles.ModalContent}
        >
            <Button type={ButtonType.Clear} onClick={onClose} className={styles.CloseButton}>
                <SvgIcon iconName="close" />
                <span className="visuallyHidden">{translations.closeModal}</span>
            </Button>
            {title && <h2 className={styles.Title}>{title}</h2>}
            {children}
        </Modal>
    );
};
